import React, { useState } from "react";
import { connect } from "react-redux";
import { cancelEvent } from "../../../actions/admin/scheduled-event-actions";
import { Modal, ModalBody } from "reactstrap";
import Loader from "../../../components/Loader/Loader";
import { notification } from "../../../utils/utility";

const CancelModal = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [reason, setReason] = useState("");

  const { data } = props;

  /**
   * on cancel event
   */
  const onCancel = () => {
    const { cancelEvent, handleClose, handleViewDetailClose, loadBookings } = props;

    setIsLoading(true);
    cancelEvent({
      data: {
        booking_id: data.id,
        cancellation_reason: reason,
      },
      onSuccess: () => {
        setIsLoading(false);
        notification.success("Event is successfully canceled");
        handleClose();
        handleViewDetailClose();
        loadBookings();
      },
      onError: (error) => {
        console.error(error);
        setIsLoading(false);
        notification.error(
          error?.response?.data?.message || "Could not cancel the booking. Please try again."
        );
      },
    });
  };

  return (
    <>
      <Loader isShowLoader={isLoading} />
      <Modal
        isOpen={props.showCancelModal}
        toggle={props.handleClose}
        centered
        modalClassName="mc-cancel-modal"
      >
        <ModalBody className="p-0">
          {/* ── Header ─────────────────────────────────────────── */}
          <div className="mc-cx__header">
            <span className="mc-cx__icon" aria-hidden="true">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </span>
            <button className="mc-cx__close" onClick={props.handleClose} aria-label="Close">×</button>
          </div>

          {/* ── Body ───────────────────────────────────────────── */}
          <div className="mc-cx__body">
            <h2 className="mc-cx__title">Cancel this booking?</h2>
            <p className="mc-cx__desc">
              A cancellation email will be sent to the invitee. This action cannot be undone.
            </p>

            {data && (
              <div className="mc-cx__summary">
                <span className="mc-cx__summary-name">{data.invitee}</span>
                <span className="mc-cx__summary-when">
                  {data.when} · {data.start_time} – {data.end_time}
                </span>
              </div>
            )}

            <label className="mc-cx__label" htmlFor="mc-cancel-reason">
              Reason (optional)
            </label>
            <textarea
              id="mc-cancel-reason"
              className="mc-cx__textarea"
              placeholder="Let the invitee know why you're cancelling…"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>

          {/* ── Footer ─────────────────────────────────────────── */}
          <div className="mc-cx__footer">
            <button className="mc-cx__btn mc-cx__btn--keep" onClick={props.handleClose}>
              Keep booking
            </button>
            <button className="mc-cx__btn mc-cx__btn--cancel" onClick={onCancel}>
              Yes, cancel
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default connect(null, {
  cancelEvent,
})(CancelModal);
